import React from 'react'
import { IonSkeletonText } from '@ionic/react'
import './styles.scss'

const CircleCardSkeleton = () => {
  return (
    <figure className='product-squared-card-skeleton'>
      <IonSkeletonText animated />
    </figure>
  )
}

export default CircleCardSkeleton
